const formatCurrency = (amount) => {
  const formatSettings = new Intl.NumberFormat(window.locale, {
    style: "currency",
    currency: window.productData.currency_code,
  });
  return formatSettings.format(amount);
};

export default formatCurrency;
